'use client'

import { useTranslations } from 'next-intl'
import { ITranslationKey } from '@/components/t'
import { ICommonProps } from '@/features/common/common-props'
import {
    GooglePlacesRestaurantsSearch,
    IGoogleAddressOption,
} from '@/features/google-places/google-places-restaurants-search'
import { usePreloadImage } from '@/utils/image/use-preload-image'

interface ICommonPlacesSearchProps extends ICommonProps {
    inputClassName?: string
    containerClassName?: string
    onSelect?: (option: IGoogleAddressOption | null) => void
}

export const CommonPlacesSearch = ({
    inputClassName,
    containerClassName,
    tBaseKey,
    onSelect,
}: ICommonPlacesSearchProps) => {
    usePreloadImage('/_images/screens/iphone-frame.svg')

    const t = useTranslations()

    return (
        <GooglePlacesRestaurantsSearch
            autoFocus={false}
            onSelect={onSelect}
            placeholder={t(`${tBaseKey}.searchPlaceholder` as ITranslationKey)}
            inputClassName={inputClassName}
            containerClassName={containerClassName}
        />
    )
}
